import { Box, useTheme } from '@mui/material'
import { PropsIndicator } from '../types/indicator.types'
import { getBgColor, getSize } from '../utils'

/**
 *
 * Indicator berfungsi sebagai representasi status atau perubahan informasi.
 */
export const Indicator = ({ color = 'primary', size = 'small', variant = 'circle', pulse = false }: PropsIndicator) => {
  const theme = useTheme()
  const backgroundColor = getBgColor(theme, color)

  return (
    <Box
      width={getSize(size)}
      height={getSize(size)}
      bgcolor={backgroundColor}
      sx={{
        borderRadius: variant === 'box' ? '2px' : '100px',
        ...(pulse && {
          animation: 'indicatorPulse 1.5s ease-out infinite',
          '@keyframes indicatorPulse': {
            '0%': { boxShadow: `0 0 0 0 ${backgroundColor}` },
            '70%, 100%': { boxShadow: '0 0 0 6px transparent' }
          },
          '@media (prefers-reduced-motion: reduce)': { animation: 'none' }
        })
      }}
    />
  )
}
